import valueHandler from "../utils/valueHandler";

/* @ngInject */
const sizeInterceptor = (
  utils,
) => {
  const self = {}

  return self
}
export default sizeInterceptor



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/interceptors/sizeInterceptor.js